module.exports = __webpack_public_path__ + "img/roombox-login.aa7ebe7f.png";